import { useTheme } from 'foundations-theming/utils';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { memo } from 'react';
import StyledUIFileAttachment from './StyledUIFileAttachment';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const FileAttachmentWithProgress = ({
  fileName,
  progress
}) => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(StyledUIFileAttachment, {
    fileName: /*#__PURE__*/_jsx(TruncateString, {
      children: fileName
    }),
    size: "small",
    style: {
      backgroundColor: trellisTheme.color['do-not-use-gypsum']
    },
    "data-test-id": "file-attachment-with-progress",
    children: /*#__PURE__*/_jsx(NanoProgress, {
      value: progress,
      boxShadow: false
    })
  });
};
export default /*#__PURE__*/memo(FileAttachmentWithProgress);